import {AxiosPromise} from 'axios';
import httpClient from 'api/httpClient';

export interface MonthComparablesGMVResponse {
    success: boolean;
    results: {
        current_month_order_count: number;
        current_month_total_value: number;
        current_month_payments_collected: number;
        last_month_order_count: number;
        last_month_total_value: number;
        last_month_payments_collected: number;
        order_count_difference: number;
        payments_difference: number;
        total_value_difference: number;
        order_count_percent_change: number;
        total_value_percent_change: number;
        payments_percent_change: number;
    };
}

export interface ActivePromotionsCountResponse {
    success: boolean;
    results: {
        active_promotion_count: number;
    };
}

export interface ActiveCustomerMembershipsCountResponse {
    success: boolean;
    results: {
        active_membership_customers: number;
    };
}

export const getDropOffGMV = (businessId: number): AxiosPromise<MonthComparablesGMVResponse> => {
    return httpClient({
        method: 'GET',
        url: `common/barry/analytics/business/${businessId}/drop-off-gmv`,
    });
};

export const getThirdPartyDeliveryGMV = (businessId: number): AxiosPromise<MonthComparablesGMVResponse> => {
    return httpClient({
        method: 'GET',
        url: `common/barry/analytics/business/${businessId}/third-party-delivery-gmv`,
    });
};

export const getOwnDriverDeliveryGMV = (businessId: number): AxiosPromise<MonthComparablesGMVResponse> => {
    return httpClient({
        method: 'GET',
        url: `common/barry/analytics/business/${businessId}/own-driver-delivery-gmv`,
    });
};

export const getSelfServeGMV = (businessId: number): AxiosPromise<MonthComparablesGMVResponse> => {
    return httpClient({
        method: 'GET',
        url: `common/barry/analytics/business/${businessId}/self-serve-gmv`,
    });
};

export const getInvoiceGMV = (businessId: number): AxiosPromise<MonthComparablesGMVResponse> => {
    return httpClient({
        method: 'GET',
        url: `common/barry/analytics/business/${businessId}/invoice-gmv`,
    });
};

export const getActivePromotionCount = (businessId: number): AxiosPromise<ActivePromotionsCountResponse> => {
    return httpClient({
        method: 'GET',
        url: `common/barry/analytics/business/${businessId}/active-promotions`,
    });
};

export const getActiveCustomerMemberships = (businessId: number): AxiosPromise<ActiveCustomerMembershipsCountResponse> => {
    return httpClient({
        method: 'GET',
        url: `common/barry/analytics/business/${businessId}/active-customer-memberships`,
    });
};
